import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@environments/environment';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    googleMapsLoaded: () => void;
  }
}

window.googleMapsLoaded = (): void => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
};

export const loadGoogleMapsScript = (): Promise<void> => {
  return new Promise<void>((resolve) => {
    const googleMapsScript = document.createElement('script');
    googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleCloudPlatformApiKey}&callback=googleMapsLoaded`;
    googleMapsScript.onload = (): void => {
      resolve();
    };
    googleMapsScript.onerror = (error): void => {
      console.error('Error loading Google Maps script:', error);
      resolve(); // Resolve the Promise even on error to prevent app crash
    };
    document.body.appendChild(googleMapsScript);
  });
};
